import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Employeetracker.css";

function Employeetracker() {
  const [logins, setLogins] = useState([]);
  const [search, setSearch] = useState("");
  const tableBodyRef = useRef();

  useEffect(() => {
    fetch("https://hrms.urbango.co.in/server/index.php?endpoint=login-activity")
      .then(res => res.json())
      .then((data) => setLogins(Array.isArray(data) ? data : []))
      .catch(() => setLogins([]));
  }, []);

  // Auto scroll after load
  useEffect(() => {
    if (logins.length <= 10) return;
    const handle = setTimeout(() => {
      const isMobile = window.innerWidth <= 700;
      const targetIdx = isMobile ? 5 : 10;
      if (tableBodyRef.current) {
        const row = tableBodyRef.current.querySelectorAll("tr")[targetIdx];
        if (row) row.scrollIntoView({ block: "start", behavior: "smooth" });
      }
    }, 350);
    return () => clearTimeout(handle);
  }, [logins]);

  // Filter logic (simple search)
  const filteredLogins = logins.filter(
    (l) =>
      l.username?.toLowerCase().includes(search.toLowerCase()) ||
      l.device?.toLowerCase().includes(search.toLowerCase()) ||
      l.os?.toLowerCase().includes(search.toLowerCase()) ||
      l.browser?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="tracker-container container-xxl py-4">
      <div className="tracker-glass p-4">
        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
          <h2 className="tracker-title mb-0">Employee Login Activities </h2  >

          {/* Search Bar (optional for admin) */}
          <input
            type="text"
            placeholder="Search employee or device..."
            className="form-control mt-3 mt-md-0"
            style={{
              maxWidth: "280px",
              background: "rgba(255, 255, 255, 0.6)",
              border: "1px solid rgba(255,255,255,0.2)",
              backdropFilter: "blur(10px)",
              color: "white",
            }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="tracker-scroll-wrap table-responsive">
          <table className="tracker-table table align-middle">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Username</th>
                <th>Login Time</th>
                <th>Device</th>
                <th>OS</th>
                <th>Browser</th>
                <th>IP Address</th>
                <th>Latitude</th>
                <th>Longitude</th>
              </tr>
            </thead>
            <tbody ref={tableBodyRef}>
              {filteredLogins.length === 0 ? (
                <tr>
                  <td colSpan={9} className="text-center text-secondary py-3">
                    No login data found.
                  </td>
                </tr>
              ) : (
                filteredLogins.map((l, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{l.username || "—"}</td>
                    <td>{l.loginTime || "—"}</td>
                    <td>{l.device || "—"}</td>
                    <td>{l.os || "—"}</td>
                    <td>{l.browser || "—"}</td>
                    <td>{l.ip || "—"}</td>
                    <td>{l.latitude || "—"}</td>
                    <td>{l.longitude || "—"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Employeetracker;
